module.exports = __webpack_public_path__ + "static/media/Group-1259@2x.3b037404.png";